import { forwardRef, useState } from "react";

const Input = forwardRef(function Input({
  label,
  hint,
  error,
  value,
  defaultValue,
  placeholder,
  type = "text",
  iconLeft = null,
  disabled = false,
  id,
  onChange,
  style,
  ...rest
}, ref) {
  const [focus, setFocus] = useState(false);
  const inputId = id || (label ? `in-${label.replace(/\s+/g, "-").toLowerCase()}` : undefined);
  const borderColor = error ? "var(--danger)" : focus ? "var(--brand)" : "var(--border-default)";

  const wrap = {
    display: "flex",
    alignItems: "center",
    gap: "var(--space-2)",
    background: disabled ? "var(--surface-sunken)" : "var(--surface-raised)",
    border: `1px solid ${borderColor}`,
    borderRadius: "var(--radius-md)",
    padding: "0 14px",
    height: 46,
    boxShadow: focus && !error ? "var(--shadow-focus)" : "none",
    transition: "border-color var(--dur-base) var(--ease-standard), box-shadow var(--dur-base) var(--ease-standard)",
    opacity: disabled ? 0.6 : 1,
  };

  const field = {
    border: "none",
    outline: "none",
    background: "transparent",
    flex: 1,
    width: "100%",
    minWidth: 0,
    fontFamily: "var(--font-body)",
    fontSize: "var(--text-base)",
    color: "var(--text-primary)",
  };

  return (
    <label htmlFor={inputId} style={{ display: "block", fontFamily: "var(--font-body)", ...style }}>
      {label && (
        <span style={{ display: "block", fontSize: "var(--text-sm)", fontWeight: "var(--weight-semibold)", color: "var(--text-primary)", marginBottom: 6 }}>
          {label}
        </span>
      )}
      <div style={wrap}>
        {iconLeft && <span style={{ display: "flex", color: "var(--text-muted)" }}>{iconLeft}</span>}
        <input
          ref={ref}
          id={inputId}
          type={type}
          value={value}
          defaultValue={defaultValue}
          placeholder={placeholder}
          disabled={disabled}
          onChange={onChange}
          style={field}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          {...rest}
        />
      </div>
      {(hint || error) && (
        <span style={{ display: "block", fontSize: "var(--text-xs)", color: error ? "var(--danger)" : "var(--text-muted)", marginTop: 5 }}>
          {error || hint}
        </span>
      )}
    </label>
  );
});

export default Input;
